import { render, staticRenderFns } from "./Tsoft.vue?vue&type=template&id=555cd4c5&scoped=true"
import script from "./Tsoft.vue?vue&type=script&lang=js"
export * from "./Tsoft.vue?vue&type=script&lang=js"
import style0 from "./Tsoft.vue?vue&type=style&index=0&id=555cd4c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555cd4c5",
  null
  
)

export default component.exports